import React from 'react';
import toast from 'react-hot-toast';
import { isMobileOnly as isMobile } from 'react-device-detect';
import './watchlist.m.css';

const WatchlistImage = () => (
  <img src="/icons/watchlist-toast.svg" alt="Icon" styleName="watchlist-image" />
);
// const LimitImage = () => (
//   <img src="/icons/watchlist-limit-toast.svg" alt="Icon" styleName="limit-image" />
// );
// const SubscribeButton = () => (
//   // <a href="/subscription?src=watchlist">
//   //   <button styleName="subscribe-button">Subscribe</button>
//   // </a>
//   <></>
// );
// const PremiumIcon = () => (
//   <img src="/icons/premium_star_bg.svg" alt="Icon" styleName="premium-icon" />
// );

export const toastStock = (stockName, text, customClass = '') => {
  if (isMobile && stockName.length > 25) {
    stockName = stockName.slice(0, 25) + '...';
  }
  toast.custom(
    <div styleName={`toast-common-style ${customClass}`}>
      <WatchlistImage />
      <div styleName="message">
        <b>{stockName}</b>&nbsp;{text}
      </div>
    </div>,
    { id: stockName + ' ' + text },
  );
};

export const toastDeleteStock = (stockName, text, setUndoDetails, data, currentTab) => {
  const clickedOnUndo = () => {
    setUndoDetails({ stock: data, listName: currentTab });
  };
  if (isMobile && stockName.length > 25) {
    stockName = stockName.slice(0, 25) + '...';
  }
  toast.custom(
    <div styleName="toast-common-style">
      <WatchlistImage />
      <div styleName="message">
        <b>{stockName}</b> {text}
      </div>
      <span onClick={() => clickedOnUndo()} styleName="undo-button">
        Undo
      </span>
    </div>,
  );
};

// export const toastLimitReached = (limit, text, customClass = '') => {
//   toast.custom(
//     <div styleName={`toast-common-style ${customClass}`} style={{ fontWeight: 500 }}>
//       <LimitImage />
//       <div styleName="message">
//         {limit}&nbsp;{text}
//       </div>
//       <SubscribeButton />
//     </div>,
//     { id: 'limit' },
//   );
// };
//
// export const toastOnlySubscriber = (tab, text, customClass = '') => {
//   toast.custom(
//     <div styleName={`toast-common-style ${customClass}`} style={{ fontWeight: 500 }}>
//       <PremiumIcon />
//       <div styleName="message">
//         {text}&nbsp;"{tab}"
//       </div>
//       <SubscribeButton />
//     </div>,
//     { id: tab },
//   );
// };
